import { useNavigate } from "react-router-dom";
import { Bell, CheckCheck } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { api } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { useFetch } from "@/hooks/useFetch";

export const NotificationBell = () => {
  const nav = useNavigate();
  const { data, reload } = useFetch("/notifications?limit=10", [], { poll: 30000 });
  const unread = data?.unread || 0;

  const open = async (n) => {
    if (!n.read) await api.post(`/notifications/${n.id}/read`);
    reload();
    if (n.link) nav(n.link);
  };
  const readAll = async () => {
    await api.post("/notifications/read-all");
    reload();
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button data-testid="notification-bell" aria-label="Notifiche" className="relative h-11 w-11 rounded-lg flex items-center justify-center text-slate-700 hover:bg-slate-100">
          <Bell className="h-6 w-6" />
          {unread > 0 && (
            <span data-testid="notification-unread-count" className="absolute top-1 right-1 min-w-[20px] h-5 px-1 rounded-full bg-red-600 text-white text-xs font-bold flex items-center justify-center">
              {unread > 99 ? "99+" : unread}
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-[340px] p-0">
        <div className="flex items-center justify-between px-4 h-12 border-b">
          <span className="font-heading font-semibold">Notifiche</span>
          {unread > 0 && (
            <button data-testid="notifications-read-all" onClick={readAll} className="inline-flex items-center gap-1 text-sm text-primary font-semibold">
              <CheckCheck className="h-4 w-4" /> Segna tutte lette
            </button>
          )}
        </div>
        <ul className="max-h-[360px] overflow-y-auto divide-y">
          {(data?.items || []).length === 0 && <li className="px-4 py-6 text-sm text-slate-500 text-center">Nessuna notifica</li>}
          {(data?.items || []).map((n) => (
            <li key={n.id}>
              <button data-testid={`notification-item-${n.id}`} onClick={() => open(n)} className={`w-full text-left px-4 py-3 hover:bg-slate-50 ${n.read ? "" : "bg-primary/5"}`}>
                <div className="flex items-start gap-2">
                  {!n.read && <span className="mt-1.5 h-2 w-2 rounded-full bg-primary shrink-0" />}
                  <div className="min-w-0">
                    <div className="text-sm font-semibold text-slate-900">{n.title}</div>
                    <div className="text-sm text-slate-600 truncate">{n.body}</div>
                    <div className="text-xs text-slate-400 mt-0.5">{fmtDateTime(n.created_at)}</div>
                  </div>
                </div>
              </button>
            </li>
          ))}
        </ul>
        <button data-testid="notifications-see-all" onClick={() => nav("/notifiche")} className="w-full h-11 border-t text-sm font-semibold text-primary hover:bg-slate-50">
          Vedi tutte le notifiche
        </button>
      </PopoverContent>
    </Popover>
  );
};
